import { EXPOSE_STOREFRONT_ADDRESS_AS_SHIPPING_ADDRESS_240820 } from "@faire/web-api/indigofair/settings/EXPOSE_STOREFRONT_ADDRESS_AS_SHIPPING_ADDRESS_240820";

import { getSettingValueWithoutAssignment } from "./__internal__/getSetting";

export const getSettingExposeStorefrontAddressAsShippingAddress =
  (): boolean => {
    return getSettingValueWithoutAssignment(
      EXPOSE_STOREFRONT_ADDRESS_AS_SHIPPING_ADDRESS_240820,
      false
    );
  };
